

// import React, { useState } from 'react';
// import { FiClock } from 'react-icons/fi';
// import styles from "../../assets/scss/Notifications/Notifications.module.scss";
// import Pagination from '../../Components/Common/Pagination';

// const notificationsData = [
//     {
//         id: 1,
//         name: "Viswa",
//         avatar: "https://randomuser.me/api/portraits/men/1.jpg",
//         action: "added a New Project",
//         item: "Tomato",
//         time: "Just Now"
//     },
//     {
//         id: 2,
//         name: "Viswa",
//         avatar: "https://randomuser.me/api/portraits/women/2.jpg",
//         action: "added a New Product Category",
//         item: "Tomato",
//         time: "Just Now"
//     },
//     {
//         id: 3,
//         name: "Viswa",
//         avatar: "https://randomuser.me/api/portraits/men/3.jpg",
//         action: "added a New Sales List",
//         item: "May Month",
//         time: "Just Now"
//     },
//     {
//         id: 4,
//         name: "Viswa",
//         avatar: "https://randomuser.me/api/portraits/men/4.jpg",
//         action: "has updated invoice",
//         item: "#01234",
//         time: "Just Now"
//     },
//     {
//         id: 5,
//         name: "Viswa",
//         avatar: "https://randomuser.me/api/portraits/men/5.jpg",
//         action: "added a New Product Category",
//         item: "Tomato",
//         time: "Just Now"
//     }
// ];

// const Notifications = () => {
//     // Pagination state
//     const [currentPage, setCurrentPage] = useState(1);
//     const [limit, setLimit] = useState(10);

//     const totalPages = Math.ceil(notificationsData.length / limit);

//     // Calculate paginated data
//     const startIndex = (currentPage - 1) * limit;
//     const paginatedData = notificationsData.slice(startIndex, startIndex + limit);

//     return (
//         <div className={styles.notificationsContainer}>
//             <h2 className={styles.header}>Notifications</h2>
//             <div className={styles.notificationsList}>
//                 {paginatedData.map((notification) => (
//                     <div key={notification.id} className={styles.notificationItem}>
//                         <img
//                             src={notification.avatar}
//                             alt={notification.name}
//                             className={styles.avatar}
//                         />
//                         <div className={styles.content}>
//                             <p>
//                                 <strong>{notification.name}</strong> {notification.action}{" "}
//                                 <strong>{notification.item}</strong>
//                             </p>
//                             <span className={styles.time}>
//                                 <FiClock className={styles.clockIcon} /> {notification.time}
//                             </span>
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             <div className={styles.paginationWrapper}>
//                 <Pagination
//                     currentPage={currentPage}
//                     totalPages={totalPages}
//                     onPageChange={setCurrentPage}
//                 />
//                 <select
//                     className={styles.inputsbtn}
//                     value={limit}
//                     onChange={(e) => {
//                         setLimit(Number(e.target.value));
//                         setCurrentPage(1);
//                     }}
//                 >
//                     <option value={10}>10 rows</option>
//                     <option value={25}>25 rows</option>
//                     <option value={50}>50 rows</option>
//                 </select>
//             </div>
//         </div>
//     );
// };

// export default Notifications;


// import React, { useState } from 'react';
// import { FiClock } from 'react-icons/fi';
// import styles from "../../assets/scss/Notifications/Notifications.module.scss";
// import Pagination from '../../Components/Common/Pagination';
// import { useGetNotificationsQuery } from '../../slices/admin/admin';

// const Notifications = () => {
//     const [currentPage, setCurrentPage] = useState(1);
//     const [limit, setLimit] = useState(10);

//     // Calculate offset
//     const offset = currentPage;

//     // Fetch with offset + limit
//     const { data, isLoading, isError } = useGetNotificationsQuery({ offset, limit });

//     if (isLoading) return <p>Loading notifications...</p>;
//     if (isError) return <p>Error loading notifications</p>;

//     const notifications = data?.data || [];
//     const totalPages = Math.ceil((data?.total || 0) / limit);

//     return (
//         <div className={styles.notificationsContainer}>
//             <h2 className={styles.header}>Notifications</h2>
//             <div className={styles.notificationsList}>
//                 {notifications.length > 0 ? (
//                     notifications.map((notification) => (
//                         <div key={notification._id} className={styles.notificationItem}>
//                             <img
//                                 src={notification.createdBy?.profile || "https://via.placeholder.com/40"}
//                                 alt={notification.createdBy?.firstName}
//                                 className={styles.avatar}
//                             />
//                             <div className={styles.content}>
//                                 <p>
//                                     <strong>
//                                         {notification.createdBy?.firstName} {notification.createdBy?.lastName}
//                                     </strong>{" "}
//                                     {notification.message}
//                                 </p>
//                                 <span className={styles.time}>
//                                     <FiClock className={styles.clockIcon} />{" "}
//                                     {new Date(notification.createdAt).toLocaleString()}
//                                 </span>
//                             </div>
//                         </div>
//                     ))
//                 ) : (
//                     <p>No notifications found.</p>
//                 )}
//             </div>

//             <div className={styles.paginationWrapper}>
//                 <Pagination
//                     currentPage={currentPage}
//                     totalPages={totalPages}
//                     onPageChange={setCurrentPage}
//                 />
//                 <select
//                     className={styles.inputsbtn}
//                     value={limit}
//                     onChange={(e) => {
//                         setLimit(Number(e.target.value));
//                         setCurrentPage(1); // reset page when limit changes
//                     }}
//                 >
//                     <option value={10}>10 rows</option>
//                     <option value={25}>25 rows</option>
//                     <option value={50}>50 rows</option>
//                 </select>
//             </div>
//         </div>
//     );
// };

// export default Notifications;

import React, { useEffect, useState } from 'react';
import { FiClock } from 'react-icons/fi';
import styles from "../../assets/scss/Notifications/Notifications.module.scss";
import Pagination from '../../Components/Common/Pagination';
import { useGetNotificationsQuery, useGetUnreadCountQuery } from '../../slices/admin/admin';
import { BaseURL } from '../../lib/api';
import dummyProfile from "../../assets/images/Profile.png";

const Notifications = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const offset = currentPage;

    // ✅ Fix for handling both absolute & relative profile URLs
const resolveImageUrl = (path) => {
  if (!path) return null;
  return path.startsWith("http") ? path : `${BaseURL}/${path}`;
};


    const { data, isLoading, isError } = useGetNotificationsQuery({ offset, limit });

    const { refetch: refetchUnreadCount } = useGetUnreadCountQuery();

    useEffect(() => {
        refetchUnreadCount();
    }, [refetchUnreadCount]);

    if (isLoading) return <p>Loading notifications...</p>;
    if (isError) return <p>Error loading notifications</p>;

    const notifications = data?.data || [];

    console.log(notifications,"notificationsnotifications");
    
    const totalPages = Math.ceil((data?.total || 0) / limit);

    return (
        <div className={styles.notificationsContainer}>
            <h2 className={styles.header}>Notifications</h2>
            <div className={styles.notificationsList}>
                {notifications.length > 0 ? (
                    notifications.map((notification) => (

                        <div
                            key={notification._id}
                            className={`${styles.notificationItem} ${!notification.isRead ? styles.unread : ""}`}
                        >
                            <img
                                // src={
                                //     notification.createdBy?.profile
                                //         ? `${BaseURL}/${notification.createdBy.profile}`
                                //         : dummyProfile
                                // }
                                src={
  notification.createdBy?.profile
    ? resolveImageUrl(notification.createdBy.profile)
    : dummyProfile
}

                                alt={notification.storeName ? notification.storeName : notification.createdBy?.firstName}
                                className={styles.avatar}
                            />
                            <div className={styles.content}>
                                <p>
                                    <strong>
                                        {notification.storeName ? notification.storeName : `${notification.createdBy?.firstName} ${notification.createdBy?.lastName}`}
                                    </strong>{" "}
                                    {notification.message}
                                </p>

                                <span
                                    className={`${styles.time} ${!notification.isRead ? styles.unreadTime : ""}`}
                                >
                                    <FiClock className={styles.clockIcon} />{" "}
                                    {new Date(notification.createdAt).toLocaleString()}
                                </span>

                            </div>
                        </div>

                    ))
                ) : (
                    <p>No notifications found.</p>
                )}
            </div>

            <div className={styles.paginationWrapper}>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                />
                <select
                    className={styles.inputsbtn}
                    value={limit}
                    onChange={(e) => {
                        setLimit(Number(e.target.value));
                        setCurrentPage(1);
                    }}
                >
                    <option value={10}>10 rows</option>
                    <option value={25}>25 rows</option>
                    <option value={50}>50 rows</option>
                </select>
            </div>
        </div>
    );
};

export default Notifications;


